import PropTypes from 'prop-types'
import {
  Container, Row, Col,
} from 'react-bootstrap'
import { Breadcrumb } from 'antd'
import { MitraCard, MitraCardLoading } from 'components/elements'

const VisitSiplah = ({ mitraData }) => (
  <div className="h-100">

    {/*= ========= breadcrumb section ========== */}
    <section className="py-4 bg-pearl-blue">
      <Container className="section-header">
        <Breadcrumb>
          <Breadcrumb.Item>
            <a href="/">Home</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Kunjungi SIPLah</Breadcrumb.Item>
        </Breadcrumb>
      </Container>
    </section>

    {/*= ========= mitra section ========== */}
    <section className="py-5">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2>MITRA SIPLAH</h2>
          <h3>Kunjungi Mitra SIPLah</h3>
          <p>Klik mitra SIPLah dan mulai berbelanja!</p>
        </div>
        <Row className="justify-content-center">
          {mitraData.isFetching ? (
            [1, 2, 3].map(item => (
              <Col key={item} lg={3} className="mb-4">
                <MitraCardLoading />
              </Col>
            ))
          ) : (
              mitraData?.list?.length > 0
                ? mitraData?.list?.map(item => (
                  <Col key={item.id} lg={3} className="mb-4">
                    <MitraCard
                      logo={item.logo_path}
                      name={item.name}
                      url={item.website}
                      registUrl={item.registration_url}
                      phone={item.contact_number}
                      guideUrl={item.guide_url}
                    />
                  </Col>
                ))
                : <span>Belum ada mitra</span>
          )}
        </Row>
      </Container>
    </section>

    {/*= ========= mitra section ========== */}
    <section className="py-5">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h3>Keterangan</h3>
          <p className="w-50 mx-auto">
            Bagi Satuan Pendidikan yang terkendala dalam proses transaksi dan bagi Penyedia yang terkendala teknis dalam proses registrasi,
            verifikasi, dan transaksi dapat menghubungi Mitra Pasar Daring SIPLah terkait (sesuai dengan masing-masing mitra).
          </p>
        </div>
      </Container>
    </section>

    {/*= ========= mitra section ========== */}
    <section className="py-5 bg-pearl-blue">
      <Container className="section-header">
        <div className="title-wrapper text-center mb-5">
          <h2>HUBUNGI KAMI</h2>
          <p className="w-50 mx-auto">
            Klik tombol di bawah untuk diarahkan ke Whatsapp kami, apabila Anda telah membaca FAQ di website mitra,
            menghubungi penyedia dan mitra SIPLah, namun belum mendapatkan jawaban terhadap pertanyaan Anda.
          </p>
          <a href="https://api.whatsapp.com/send?phone=6281281435091"><img src="https://siplah.kemendikdasmen.go.id/themes/user/site/default/asset/img/home/wa_button.png" alt="" style={{ padding: '20px', width: '15%' }} /></a>
        </div>
      </Container>
    </section>
  </div>
)

VisitSiplah.propTypes = {
  mitraData: PropTypes.object,
}

export default VisitSiplah
